module.exports = __webpack_public_path__ + "img/china_telecom.5d47f115.svg";